<template>
    <router-view appear :key="path"></router-view>
</template>


<script>
export default {
  name: "HomeModule",
  components: {},
  data: () => ({
    path: null
  }),
};
</script>
